import { useRef } from "react";
import { AnimatePresence, motion } from "motion/react";

import useWizard from "./useWizard";
import { getStepComponent } from "./steps";

const variants = {
  enter: (goingForward) => ({
    opacity: 0,
    x: goingForward ? 300 : -300,
  }),
  center: { opacity: 1, x: 0 },
  exit: (goingForward) => ({
    opacity: 0,
    x: goingForward ? -300 : 300,
  }),
};

export default function WizardStepAnimator() {
  const { currentStep, currentSubStep, directionOverrideRef } = useWizard();
  const prevRef = useRef({ step: currentStep, sub: currentSubStep });
  const directionRef = useRef(true);

  const prevStep = prevRef.current.step;
  const prevSub = prevRef.current.sub;

  if (currentStep !== prevStep || currentSubStep !== prevSub) {
    if (directionOverrideRef.current !== null) {
      directionRef.current = directionOverrideRef.current;
      directionOverrideRef.current = null;
    } else {
      directionRef.current =
        currentStep > prevStep ||
        (currentStep === prevStep && currentSubStep > prevSub);
    }
    prevRef.current = { step: currentStep, sub: currentSubStep };
  }

  const key = `${currentStep}-${currentSubStep}`;
  const StepComponent = getStepComponent(currentStep);

  return (
    <AnimatePresence mode="wait" custom={directionRef.current} initial={false}>
      <motion.div
        key={key}
        custom={directionRef.current}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ duration: 0.2, ease: "easeInOut" }}
        style={{ minHeight: "100%" }}
      >
        {StepComponent && <StepComponent subStep={currentSubStep} />}
      </motion.div>
    </AnimatePresence>
  );
}
